import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'shippingOptionsFromBag';
let SWITCHED = false;

function splitTable(original) {
  original.wrap('<div class="table-wrapper" />');
  const copy = original.clone(true, true);
  original.wrap('<div class="scrollable" />');

  original.css({
    'margin-left': copy.width(),
  });
  copy.css({
    width: copy.width(),
  });
}

function unsplitTable(original) {
  original.closest('.table-wrapper').find('.pinned').remove();
  original.css({
    'margin-left': 0,
  });
  original.unwrap();
  original.unwrap();
}

// Responsive Tables
function updateTables() {
  if (($(window).width() < 767) && !SWITCHED) {
    SWITCHED = true;
    $('table.responsive').each((i, element) => {
      splitTable($(element));
    });
    return true;
  } else if (SWITCHED && ($(window).width() > 767)) {
    SWITCHED = false;
    $('table.responsive').each((i, element) => {
      unsplitTable($(element));
    });
  }
  return false;
}

function usTableInsert() {
  $.get('../src/partials/shipping-options-us-table.html', (data) => {
    $('#shipContentBag').html(data);
    SWITCHED = false;
    updateTables();
    $(window).bind('resize', updateTables);
  });
}

function rowTableInsert() {
  $.get('../src/partials/shipping-options-row-table.html', (data) => {
    $('#shipContentBag').html(data);
    SWITCHED = false;
    updateTables();
    $(window).bind('resize', updateTables);
  });
}

export default function shippingOptions(el) {
  const $el = $(el);
  SWITCHED = false;
  usTableInsert();
  $el.on('change', function switchRegion() {
    const regionTableId = $(this).find('option:selected').attr('id');

    if ($('.pinned').length === 1) {
      unsplitTable($('table.responsive'));
    }

    if (regionTableId === 'usTable') {
      usTableInsert();
    } else {
      rowTableInsert();
    }
  });
}

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, shippingOptions);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/shipping-options-from-bag.js